import {
  differenceInDays,
  differenceInMinutes,
  differenceInWeeks,
  getDay
} from 'date-fns';
import { MINUTES_IN_DAY } from '../../constants';
import type { ScheduleSolversDisplayConfigType } from '../../types';
import { getDateFromControlValue } from '../../utils/get-date-obj';

export const weeklyOn = ({
  freq = 1,
  endDate,
  startDate,
  userDate,
  scheduleRepeatEnds,
  scheduleRepeatEndsDate,
  scheduleRepeatEndsOccurrences,
  daysOfWeek: derivedDaysOfWeek
}: ScheduleSolversDisplayConfigType) => {
  const daysOfWeek: number[] = derivedDaysOfWeek || [];
  const viewDurationInMinutes = differenceInMinutes(endDate, startDate);
  const fromNowToStartInMinutes = differenceInMinutes(userDate, startDate);

  if (fromNowToStartInMinutes < 0) {
    return false;
  }

  if (daysOfWeek?.length === 0) {
    daysOfWeek.push(getDay(startDate));
  }

  const daysBetweenStartAndEnd = differenceInDays(endDate, startDate);

  const timeFromStart =
    fromNowToStartInMinutes %
    (MINUTES_IN_DAY * Math.max(1, daysBetweenStartAndEnd));

  const currentStartDate = new Date(
    userDate.getTime() - timeFromStart * 60 * 1000
  );

  const weeksBetween = differenceInWeeks(startDate, userDate);

  if (
    scheduleRepeatEnds === 'onDate' &&
    userDate.getTime() >=
      getDateFromControlValue(scheduleRepeatEndsDate).getTime()
  ) {
    return false;
  }

  if (
    scheduleRepeatEnds === 'afterOccurrences' &&
    weeksBetween > freq * Number(scheduleRepeatEndsOccurrences)
  ) {
    return false;
  }

  return (
    timeFromStart <= viewDurationInMinutes &&
    daysOfWeek.includes(getDay(currentStartDate)) &&
    weeksBetween % freq === 0
  );
};
